(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('compare-banner')) {
    customElements.define(
      'compare-banner',
      class CompareBanner extends HTMLElement {
        constructor() {
          super();
          this.resizeObserver = null;
          this.slider = null;
          this.container = null;
        }

        connectedCallback() {
          this.initSlider();
          this.setupResizeObserver();
        }

        disconnectedCallback() {
          this.cleanup();
        }

        initSlider() {
          this.container = this.querySelector('.compare-container');
          this.slider = this.querySelector('.drag-slider');

          if (this.container && this.slider) {
            this.updateSliderMax();

            // Set initial position to center
            this.centerSlider();

            this.slider.addEventListener('input', (e) => {
              this.container.style.setProperty('--position', `${e.target.value}px`);
            });
          } else {
            console.error('Container or slider not found');
          }
        }

        centerSlider() {
          if (this.container && this.slider) {
            const centerPosition = this.container.clientWidth / 2;
            this.slider.value = centerPosition;
            this.container.style.setProperty('--position', `${centerPosition}px`);
          }
        }

        updateSliderMax() {
          if (this.container && this.slider) {
            this.slider.max = this.container.clientWidth;
            // Maintain current position relative to new width
            const currentValue = parseInt(this.slider.value) || this.container.clientWidth / 2;
            const percentage = currentValue / (parseInt(this.slider.max) || 1);
            this.slider.value = this.container.clientWidth * percentage;
            this.container.style.setProperty('--position', `${this.slider.value}px`);
          }
        }

        setupResizeObserver() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }

          this.resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
              if (entry.target === this.container || entry.target === this) {
                this.updateSliderMax();
              }
            }
          });

          if (this.container) {
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(this.container);
          }
        }

        cleanup() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }
          if (this.slider) {
            this.slider.removeEventListener('input', this.handleSliderInput);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
// 2. Interactive Link Showcase
class WDT_link_showcase extends HTMLElement {
  constructor() {
    super();
    this.wdtMainItems = this.querySelectorAll('.collection_showcase_content');
    this.wdtMainitem = Array.from(this.querySelectorAll('.wdt-link-showcase-item'));
    this.init();
  }

  init() {
    this.wdtMainitem.forEach(wdtItem => {
      let wdtImageItems = wdtItem.querySelectorAll('.wdt-link-follow-content');
      wdtItem.addEventListener('mousemove', (e) => {
        let x = e.offsetX;
        let y = e.offsetY;
        wdtImageItems.forEach(imageItems => {
          imageItems.style.left = `${x}px`;
          imageItems.style.top = `${y}px`;
        });
      });
    });
  }
}

customElements.define('wdt-link-interactive', WDT_link_showcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

 

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  
  

  } catch(e) { console.error(e); }
})();
})();
